export default __webpack_public_path__ + "static/media/delivery-install.37c56de1.svg";